import React, { useEffect, useContext, useCallback } from 'react';
import { Search, Grid } from 'semantic-ui-react';
import axios from 'axios';
import api from '../../config/services';

// store
import { StoreContext } from '../../store/StoreProvider';
import Act from '../../store/actions';

import characterTool from '../../commons/utils/character';

const { charConvertTable, charRegEx } = characterTool;

// handle point selected on MapContainer component
const handlePointSelected = (pointData, dispatch, transSearchData) =>
	// query for API
	axios.get(api.getPublicationInfoOfLocInfoV2.replace('{locId}', pointData.properties.locId)).then((response) => {
		// console.log('pointData ', pointData);
		const pubsOfLocAPI = response.data.data;
		// console.log(pubsOfLocAPI);
		// console.log(transSearchData);

		const yearfilter = pubsOfLocAPI.filter((item) => item.startDate <= transSearchData); // 篩選年份低於選擇年份資料

		const resultsFiltered = yearfilter.map((item, index) => ({
			key: index,
			resultindex: index + 1,
			completiondate: item.completionDate || '',
			publication: item.PublicationEn || '',
			publicationfa: item.PublicationFa || '',
			author: item.authorEn || '',
			authorfa: item.authorFa || '',
			location: item.location || '',
			birthdate: item.birthDate || '',
			deathdate: item.deathDate || '',
			placeofbirthen: item.placeOfBirthEn || '',
			placeofdeathen: item.placeOfDeathEn || '',
			metadata: item.metaData || '',
			title: '', // this is required for Semantic-ui Search component
		}));
		dispatch({
			type: Act.FINISH_SEARCH,
			results: resultsFiltered,
		});
		// select search input
		// const ele = document.querySelector('.seachInputContainer input');
		// ele.select();
	});

const onSelectResult = (data, dispatch) => {
	// update selection result
	dispatch({
		type: Act.UPDATE_SELECTION,
		payload: data && data.result ? data.result : null,
	});
	// popup modal
	dispatch({
		type: Act.POP_UP_MODAL,
		payload: !!(data && data.result),
	});
};

// convert character in search input
const convertWord = (word) => {
	const charConvert = Object.keys(charConvertTable);
	const wordAry = word.split('').map((c) => {
		if (charConvert.includes(c)) {
			return charConvertTable[c];
		}
		return c;
	});
	return wordAry.join('');
};

// convert character to regexp
const convertWordToReg = (word) => {
	const charConvertReg = Object.keys(charRegEx);
	const wordAry = word.split('').map((c) => {
		if (charConvertReg.includes(c)) {
			return charRegEx[c];
		}
		return c;
	});
	return wordAry.join('');
};

const SearchInput = () => {
	const [state, dispatch] = useContext(StoreContext);
	const { map, timeline } = state;
	const { loading, results, value, pointSelected } = map;
	const { transSearchData } = timeline;
	// const inputElement = React.useRef(); // create ref to DOM

	// handle search input change
	const timeoutRef = React.useRef();

	const handleSearchChange = useCallback(
		(e, data) => {
			// reset setTimeout when search input change
			clearTimeout(timeoutRef.current);

			// convert special character before display in search input
			// const searchWord = convertWord(data.value);
			// start search
			dispatch({ type: Act.START_SEARCH, query: data.value });

			timeoutRef.current = setTimeout(() => {
				if (data.value.length === 0) {
					dispatch({ type: Act.CLEAN_QUERY, value: '', results: [], loading: false });
				}
				// query for API.

				axios.get(api.getPublicationInfoByYear.replace('{year}', transSearchData)).then((response) => {
					const pubInfoAPI = response.data.data;
					console.log(pubInfoAPI);
					const resultsFiltered = pubInfoAPI.map((item, index) => ({
						key: index,
						resultindex: index + 1,
						completiondate: item.completionDate || '',
						publication: item.PublicationEn || '',
						publicationfa: item.PublicationFa || '',
						author: item.authorEn || '',
						authorfa: item.authorFa || '',
						location: item.location || '',
						birthdate: item.birthDate || '',
						deathdate: item.deathDate || '',
						placeofbirthen: item.placeOfBirthEn || '',
						placeofdeathen: item.placeOfDeathEn || '',
						metadata: item.metaData || '',
						title: '', // this is required for Semantic-ui Search component
					}));
					dispatch({
						type: Act.FINISH_SEARCH,
						results: resultsFiltered,
					});
				});
			}, 500);
		},
		[dispatch]
	);

	useEffect(() => {
		axios.get(api.getPublicationInfoByYear.replace('{year}', transSearchData)).then((response) => {
			const pubInfoAPI = response.data.data;
			const resultsFiltered = pubInfoAPI.map((item, index) => ({
				key: index,
				resultindex: index + 1,
				completiondate: item.completionDate || '',
				publication: item.PublicationEn || '',
				publicationfa: item.PublicationFa || '',
				author: item.authorEn || '',
				authorfa: item.authorFa || '',
				location: item.location || '',
				birthdate: item.birthDate || '',
				deathdate: item.deathDate || '',
				placeofbirthen: item.placeOfBirthEn || '',
				placeofdeathen: item.placeOfDeathEn || '',
				metadata: item.metaData || '',
				title: '', // this is required for Semantic-ui Search component
			}));
			dispatch({
				type: Act.FINISH_SEARCH,
				results: resultsFiltered,
			});
		});
	}, [transSearchData]);

	// clear tiemoutRef.current (setTimeout)
	useEffect(
		() => () => {
			clearTimeout(timeoutRef.current);
		},
		[]
	);

	// display results when map's point selected
	useEffect(() => {
		if (pointSelected && pointSelected.properties) {
			handlePointSelected(pointSelected, dispatch, transSearchData);
		}
	}, [pointSelected, dispatch]);

	return (
		// eslint-disable-next-line react/jsx-filename-extension
		<Grid divided style={{ float: 'left', padding: '20px', marginRight: '-300px', width: '300px' }}>
			<Grid.Column width={4}>
				<Search
					className="seachInputContainerTimeline"
					loading={loading}
					onResultSelect={(e, data) => onSelectResult(data, dispatch)}
					selected
					// onSearchChange={handleSearchChange}
					selectFirstResult
					onSelectionChange={(e, data) =>
						dispatch({
							type: Act.UPDATE_SELECTION,
							selection: data.result.publication,
						})
					}
					onFocus={() => {
						dispatch({
							type: Act.DISPLAY_RESULTS,
							isResultsDisplay: true,
						});
					}}
					results={results}
					style={{ width: '350px' }}
					value={value}
					aligned="left"
					open
					size="large"
					// ref={inputElement}
					resultRenderer={({ resultindex, completiondate, publication, author, location, title }) => [
						<div key="content" className="content">
							<div className="result-index-container">
								{resultindex && <span className="result-index">({resultindex})</span>}
								{/* {completiondate && <span className="completion-date">{completiondate}</span>} */}
							</div>
							{publication && <div className="title publication">Title: {publication}</div>}
							{author && <div className="author">Author: {author})</div>}
							{author && <div className="completiondate">Year: {completiondate}</div>}
							{location && <div className="Location">Location: {location}</div>}

							{title !== '' && <div className="">{title}</div>}
							<div className="result-full-entry" style={{ fontStyle: 'italic' }}>
								Full Entry
							</div>
						</div>,
					]}
				/>
			</Grid.Column>
		</Grid>
	);
};

export default SearchInput;
